import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import PublishDialogIcon from "@entrilia/shared/icons/PublishDialogIcon";
import NewsPageNotLiveDialogAlert from "../NewsPageNotLiveDialogAlert";

interface Props {
  isNewsVisibleToInvestors: boolean;
  onClose: () => void;
  onSaveConfirmed: () => void;
}

const ConfirmSaveLiveInvestorCommunicationDialog = ({ isNewsVisibleToInvestors, onClose, onSaveConfirmed }: Props) => (
  <SmallDialog open onClose={onClose}>
    <DialogTitle>Save Changes</DialogTitle>
    <DialogCloseButton onClick={onClose} />
    <DialogContent>
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <PublishDialogIcon sx={{ width: 80, height: 80 }} />
        <Stack spacing={1} sx={{ alignItems: "center" }}>
          <Typography noWrap variant="h6">
            {isNewsVisibleToInvestors ? "Publish changes to Live" : "Save changes"}
          </Typography>
          <Typography color="textSecondary" sx={{ textAlign: "center" }}>
            {isNewsVisibleToInvestors
              ? "The changes will be published on the portal and will be available to investors."
              : "The changes will be saved to this Live communication."}
          </Typography>
          {!isNewsVisibleToInvestors && <NewsPageNotLiveDialogAlert />}
        </Stack>
      </Stack>
    </DialogContent>
    <DialogButtons onCancel={onClose}>
      <Button variant="contained" onClick={onSaveConfirmed}>
        {isNewsVisibleToInvestors ? "Save & Publish" : "Save"}
      </Button>
    </DialogButtons>
  </SmallDialog>
);

export default ConfirmSaveLiveInvestorCommunicationDialog;
